export default __webpack_public_path__ + "static/media/oa_2.6cfe4e39.mp3";